<template>
  <div class="about-us">
    <menuBox :step="5"></menuBox>
    <div class="title-box">
      <div class="title">
        聯絡我們
      </div>
      <div class="l-title">
        歡迎您隨時與我們溝通
      </div>
    </div>
    <div class="about-title">
      <div class="info-box">
        <div class="title">
          與我們聯繫
        </div>
        <div class="content">
          加入我們或與我們合作，請隨時與我們聯繫
        </div>
      </div>
      <div class="sub-box">
        <input type="text" placeholder="你的名字" />
        <input type="text" placeholder="你的郵件" />
        <textarea class="message" type="text" placeholder="內容" />
        <div class="btn" @click="submit()">傳送</div>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    submit() {
      alert("send success");
    },
  },
};
</script>
<style lang="less" scoped>
.about-us {
  .title-box {
    background-color: #41289a;
    width: 100%;
    height: 400px;
    overflow: hidden;
    text-align: center;
    .title {
      font-size: 64px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      margin-top: 120px;
    }
    .l-title {
      font-size: 32px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      margin-top: 24px;
    }
  }
  .about-title {
    background-color: #fff;
    height: 650px;
    padding: 0 360px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info-box {
      width: 520px;
      .title {
        font-size: 48px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: #45289f;
        margin-top: -80px;
      }
      .content {
        font-size: 24px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #999999;
        margin-top: 40px;
      }
    }
    .sub-box {
      width: 520px;
      height: 370px;
      padding: 40px;
      background: rgba(65, 40, 154, 0.1);
      border-radius: 8px;
      input,
      textarea {
        background-color: #fff;
        width: 480px;
        padding: 0 20px;
        border-radius: 8px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        height: 48px;
        border: none;
        margin-bottom: 20px;
      }
      .message {
        height: 120px;
        padding: 20px;
      }
      .btn {
        width: 100%;
        height: 56px;
        background: #41289a;
        border-radius: 4px;
        line-height: 56px;
        font-size: 24px;
        text-align: center;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
